import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBug, faEnvelope } from '@fortawesome/free-solid-svg-icons'

export function DefaultError() {
  return (
    <div className="text-danger">
      <div className="mb-2">
        <FontAwesomeIcon icon={faBug} className="me-2" />
        Something went wrong
      </div>
      <div className="small">
        The error has been logged and will be reviewed by the ThirdLine team. If this is urgent, please contact us at{' '}
        <a href="mailto:support@thirdline.io" className="text-danger text-decoration-underline">
          <FontAwesomeIcon icon={faEnvelope} className="me-1" />
          support@thirdline.io
        </a>.
      </div>
    </div>
  )
}
